import CertificateManager from "./certificate-manager";
export default class PageModule {
	constructor() {
		this.initCertificateManager();
	}

	initCertificateManager() {
		const certificateManager = new CertificateManager();
	}
}
